import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 3.333v1.334-1.334Zm0 4v1.334-1.334Zm0 4v1.334-1.334Zm-6.667-8A1.333 1.333 0 0 0 2 4.667v2a1.333 1.333 0 1 1 0 2.666v2a1.333 1.333 0 0 0 1.333 1.334h9.334A1.334 1.334 0 0 0 14 11.333v-2a1.333 1.333 0 1 1 0-2.666v-2a1.334 1.334 0 0 0-1.333-1.334H3.333Z",
  stroke: "#18A6D2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };